
import purchasesServices from '@/services/purchases.services.js';
import messages from '@/constants/messages.js';
import mixin from "@/mixin/index.js";


const root = { root: true };

const getCheckoutSession = async ({ dispatch, commit }, checkoutSessionId, stripe, callStack = 0) => {
    try {
        commit("setLoading", true);
        if (callStack >= 8) throw new Error();
        const { sessionId } = await purchasesServices.getCheckoutSession(checkoutSessionId);
        if (!sessionId) {
            setTimeout(() => {
                getCheckoutSession({ dispatch, commit }, checkoutSessionId, stripe, callStack + 1);
            }, 1000);
            return null;
        }
        return stripe.redirectToCheckout({ sessionId });
    } catch (err) {
        commit("setLoading", false);
        dispatch("general/showError", messages.PURCHASE_ERROR, root);
        throw err;
    }
}

export default {

    createCheckoutSession: async ({ dispatch, commit }, { sessionBody, stripe }) => {
        try {
            commit("setLoading", true);
            const { checkoutSessionId } = await purchasesServices.createCheckoutSession(sessionBody);
            return await getCheckoutSession({ dispatch, commit }, checkoutSessionId, stripe);
        } catch (err) {
            commit("setLoading", false);
            dispatch("general/showError", messages.PURCHASE_ERROR, root);
            throw err;
        }
    },

    openPurchases: async ({ rootGetters, commit, dispatch }) => {
        const user = rootGetters["general/user"];
        if (process.env.VUE_APP_ENV === "partners") {
            return alert('Este item ainda não está disponível para parceiros. Acesse nosso portal https://app.vetalfa.com para ter acesso a este recurso.')
        }
        if (!user || !!user.isPremium) {
            return;
        }
        dispatch("general/logEvent", 'openPurchases', root);
        if (!mixin.methods._isCordovaApp()) {
            commit('setPurchasesModel', true);
        } else {
            commit('general/setConfirmModel', {
                active: true,
                alert: true,
                text: messages.PRO_ITEM_ON_MOBILE,
                callback: (_) => { },
                confirmText: mixin.methods._getLabel("CONTINUE"),
            }, root);
        }
    },

    createCustomersPortalLink: async ({ commit, dispatch }) => {
        try {
            if (!!mixin.methods._isCordovaApp()) {
                return;
            }
            commit("general/setLoadingOn", true, root);
            const { session } = await purchasesServices.createCustomersPortalLink(process.env.VUE_APP_STRIPE_CANCEL_URL);
            window.location.assign(session.url);
        } catch (err) {
            dispatch("general/showError", messages.PURCHASE_ERROR, root);
            throw err;
        } finally {
            commit("general/setLoadingOff", false, root);
        }
    }

}